import { apiClient } from "services/api-client"

export const getPolicyMetrics = async (companyKey) => {
    return await apiClient.get(`/policy/metrics?companyKey=${companyKey}`)
}

export const getPolicies = async (tenant) => {
    return await apiClient.get(`/policy?companyKey=${tenant}`)
}

export const getPoliciesPaged = async (tenant, page, perPage, searchContent, statusFilter) => {
    const status = statusFilter && statusFilter !== 'all' ? `&status=${encodeURIComponent(statusFilter)}` : '';
    return await apiClient.get(`/policy/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}&searchContent=${encodeURIComponent(searchContent ?? '')}${status}`)
}

export const getPolicyById = async (id) => {
    return await apiClient.get(`/policy/${id}`)
}

export const getPolicyVersionsByPolicyId = async (id) => {
    return await apiClient.get(`/policy/${id}/version`)
}

export const getPolicyVersionByPolicyIdAndVersion = async (id, idVersion) => {
    return await apiClient.get(`/policy/${id}/version/${idVersion}`)
}

export const addPolicy = async (policy) => {
    return await apiClient.post('/policy', policy)
}

export const addPolicyVersion = async (id, policyVersion) => {
  const hasFile = policyVersion?.attachment instanceof File;

  // gere uma chave única por clique no Salvar
  const idempotencyKey =
    (window.crypto?.randomUUID?.()) ?? `${Date.now()}-${Math.random()}`;

  if (hasFile) {
    const fd = new FormData();
    if (policyVersion.version != null)    fd.append('version', String(policyVersion.version));
    if (policyVersion.status != null)     fd.append('status', String(policyVersion.status));
    if (policyVersion.companyKey != null) fd.append('companyKey', String(policyVersion.companyKey));
    if (policyVersion.authorId)           fd.append('authorId', String(policyVersion.authorId));
    if (policyVersion.reviewerId)         fd.append('reviewerId', String(policyVersion.reviewerId));
    if (policyVersion.approverId)         fd.append('approverId', String(policyVersion.approverId));
    if (policyVersion.policyText != null) fd.append('policyText', String(policyVersion.policyText || ''));
    fd.append('attachment', policyVersion.attachment);
    // 👇 vai no body, não em header
    fd.append('idempotencyKey', idempotencyKey);

    return apiClient.post(`/policy/${id}/version`, fd, {
      onUploadProgress: (e) => {
        const pct = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
        console.log('upload %', pct);
      },
    });
  }

  // eslint-disable-next-line no-unused-vars
  const { attachment, ...json } = policyVersion || {};
  return apiClient.post(`/policy/${id}/version`, {
    ...json,
    idempotencyKey,
  });
};

export const editPolicy = async (id, policy) => {
    return await apiClient.put(`/policy/${id}`, policy)
}

// export const addPolicyVersion = async (id, policyVersion) => {
//     return await apiClient.post(`/policy/${id}/version`, policyVersion)
// }

export const editPolicyVersion = async (id, position, policyVersion) => {
    return await apiClient.put(`/policy/${id}/version/${position}`, policyVersion)
}

export const editPolicyVersionStatus = async (id, position, status) => {
    return await apiClient.put(`/policy/${id}/version/${position}/status`, {status})
}

export const getPendingPolicies = async (tenant, userId) => {
    return await apiClient.get(`/policy/user/${userId}/pending?companyKey=${tenant}`)
}

export const deletePolicy = async (id) => {
    return await apiClient.delete(`/policy/${id}`)
}

export const deletePolicyVersion = async (id, idVersion) => {
    return await apiClient.delete(`/policy/${id}/version/${idVersion}`)
}

export const getPolicyVersionUserById = async (id) => {
    return await apiClient.get(`/policy/version-user-accept/${id}`)
}

export const markPolicyVersionAsRead = async (id) => {
    return await apiClient.put(`/policy/version-user-accept/${id}/read`)
}

export const acceptPolicyVersion = async (id) => {
    return await apiClient.put(`/policy/version-user-accept/${id}/accepted`)
}

export const getPoliciesUserByPolicyIdAndPolicyVersionId = async (id, idVersion) => {
    return await apiClient.get(`/policy/${id}/version/${idVersion}/users-accept`)
}

export const getTotalPoliciesAcceptsByPolicyIdAndPolicyVersionId = async (id, idVersion) => {
    return await apiClient.get(`/policy/${id}/version/${idVersion}/users-accept/count`)
}

// { sent, accepted }: acceptance requests e-mailed for the version, and how many were accepted.
export const getPolicyAcceptsSummary = async (id, idVersion) => {
    return await apiClient.get(`/policy/${id}/version/${idVersion}/users-accept/summary`)
}

export const sendPolicyUserAcceptRequest = async (id, idVersion) => {
    return await apiClient.post(`/policy/${id}/version/${idVersion}/send-users-accept`)
}

// Funções para comentários e rejeições
export const getPolicyComments = async (policyId, versionId) => {
    return await apiClient.get(`/policy/${policyId}/version/${versionId}/comments`)
}

export const addPolicyComment = async (policyId, versionId, commentData) => {
    return await apiClient.post(`/policy/${policyId}/version/${versionId}/comments`, commentData)
}

// Função para recusar política com envio de email
export const rejectPolicyVersionWithEmail = async (policyId, versionId, rejectionData) => {
    return await apiClient.put(`/policy/${policyId}/version/${versionId}/reject`, rejectionData)
}

export const updatePolicyComment = async (policyId, versionId, commentId, commentData) => {
    return await apiClient.put(`/policy/${policyId}/version/${versionId}/comments/${commentId}`, commentData)
}

export const deletePolicyComment = async (policyId, versionId, commentId) => {
    return await apiClient.delete(`/policy/${policyId}/version/${versionId}/comments/${commentId}`)
}

// Função para atualizar apenas o anexo de uma versão
export const updatePolicyVersionAttachment = async (policyId, versionId, newFile) => {
    const fd = new FormData();
    fd.append('attachment', newFile);
    
    return await apiClient.put(`/policy/${policyId}/version/${versionId}/attachment`, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const regenerateAttachmentDownloadUrl = async (policyId, versionId) => {
    try {
        return await apiClient.get(`/policy/${policyId}/version/${versionId}/attachment/regenerate`);
    } catch (error) {
        console.error('Erro ao regenerar URL do anexo:', error);
        throw error;
    }
}

// Função utilitária para detectar se um erro é relacionado a URL expirada do S3
export const isS3UrlExpiredError = (error) => {
    if (!error) return false;
    
    const errorMessage = error.message || '';
    const errorResponse = error.response?.data?.message || '';
    
    // Detectar diferentes tipos de erro de URL expirada
    const expiredPatterns = [
        'AccessDenied',
        'Request has expired',
        'SignatureDoesNotMatch',
        'RequestTimeTooSkewed',
        'TokenRefreshRequired',
        'ExpiredToken',
        'Failed to fetch',
        'NetworkError',
        '403',
        '404'
    ];
    
    return expiredPatterns.some(pattern => 
        errorMessage.includes(pattern) || errorResponse.includes(pattern)
    );
}

// Função para tentar uma requisição com retry automático em caso de URL expirada
export const fetchWithS3UrlRetry = async (fetchFunction, retryFunction, maxRetries = 1) => {
    let lastError;
    
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await fetchFunction();
        } catch (error) {
            lastError = error;
            
            // Se é o último attempt ou não é erro de URL expirada, falha
            if (attempt === maxRetries || !isS3UrlExpiredError(error)) {
                throw error;
            }
            
            // Tentar regenerar URL e continuar o loop
            console.log(`Tentativa ${attempt + 1} falhou com URL expirada, regenerando...`);
            try {
                await retryFunction();
            } catch (retryError) {
                console.error('Erro ao regenerar URL:', retryError);
                throw retryError;
            }
        }
    }
    
    throw lastError;
}